<div class="msg-atch-tmp scroll-container">
  <div *ngIf="dataSource?.length > 0; else noRemTemplateView">
    <div class="reminder-template-row" *ngFor="let row of dataSource; let inx = index" [class.disabled]="row.disabled">
      <div class="row-content">
        <div class="radio-cell">
          <owc-radio
            name="radio-btn"
            class="template-radio"
            [disabled]="row.iconSets === 'yes-icon'"
            [checked]="selection.selected === row"
            (change)="onRadioChange(row, $event)"
            (click)="$event.stopPropagation()"
          >
            {{ row?.templateDetails?.templateSubject || row?.templateSubject }}
          </owc-radio>
        </div>

        <div class="template-cell">
          <div class="template-body" [innerHTML]="row?.templateDetails?.templateBody"></div>
        </div>

        <div class="icon-cell">
          <owc-icon-button family="outlined" [id]="'menu-anchor-' + inx" icon="more_vertical"></owc-icon-button>
          <owc-menu [anchor]="'menu-anchor-' + inx" limit="3" position="left">
              <owc-list-item (click)="EditMessageTemplate(inx)" class="cf-option-menu-btn">Edit</owc-list-item>
              <owc-list-item (click)="deleteReminderFromTemplate(row, inx)"
                class="cf-option-menu-btn">Delete</owc-list-item>
            </owc-menu>
        </div>
        <owc-modal-dialog [(ngModel)]="deleteButtonVisible" size="small">
            <owc-component-header slot="header">Delete message template</owc-component-header>
            <div>
              <owc-typography variant="body2">Are you sure you want to delete this message template from your
                templates?</owc-typography>
            </div>
            <owc-component-footer slot="footer">
              <owc-button (click)="closeDeleteModal()" class="cancel-btn">Cancel</owc-button>
              <owc-button (click)="confirmDelete()">Yes, delete</owc-button>
            </owc-component-footer>
          </owc-modal-dialog>
        <owc-modal-dialog [(ngModel)]="visible">
            <dl-add-own-template-dialog [data]="messageDta" (closeDialog)="onDialogClosed()"
              (templateUpdated)="onTemplateUpdated($event)">
            </dl-add-own-template-dialog>
          </owc-modal-dialog>
      </div>
      <owc-divider></owc-divider>
    </div>
  </div>

  <ng-template #noRemTemplateView>
    <p class="no-template-text">No Template present, add new Template.</p>
  </ng-template>
</div>
